import { HttpClientConfig, HttpClientInterface } from 'core/infra/http/HttpClient';
import { SchedulerLead } from 'managed-analytics/domain/SchedulerLead';
import { RawSchedulerLead, mapSchedulerLeadToApi } from './LeadMapper';

export type LeadRepositoryDependencies = {
    httpClient: HttpClientInterface;
};

export class LeadRepository {
    private readonly httpClient: HttpClientInterface;

    constructor({ httpClient }: LeadRepositoryDependencies) {
        this.httpClient = httpClient;
    }

    async createLead(schedulerLead: SchedulerLead, config?: HttpClientConfig): Promise<SchedulerLead> {
        const endpoint = '/leads/scheduler';
        const { data } = await this.httpClient.post<RawSchedulerLead, RawSchedulerLead>(
            endpoint,
            mapSchedulerLeadToApi(schedulerLead),
            config
        );
        return data as SchedulerLead;
    }
}